import React, { useState, useEffect, useRef } from 'react';
import BASE_URL from "../../../../config/config";
import { useNavigate, useLocation } from 'react-router-dom';
import JobDocumentService from "../../Controller/JobDocumentController";
import CreateJobDocument from "./CreateJobDocument";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import JobService from "../../Controller/JobController";
import HelpSite from "../../../Common/HelpLink";
function JobDocumentPage({ JobID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    JobID = localStorage.getItem('JobID');
    const [JobDocuemntList, setJobDocumentData] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentJobDocument, setCurrentJobDocument] = useState(null);
    const CompanyID = localStorage.getItem("CompanyID");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const tableRef = useRef();
    const [isClosed, SetIsClosed] = useState("0");
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    const fetchJobDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                SetIsClosed(jobDetail[0].IsCompleted);

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    useEffect(() => {
        SetIsClosed(localStorage.getItem("Closed"));
        fetchJobDetail();
        if (JobDocuemntList.length > 0) {
            initDataTable();
        }
    }, [JobDocuemntList, localStorage.getItem("Closed")]);
    useEffect(() => {

    }, []);
    const fetchJobDocument = async () => {
        try {
            const data = await JobDocumentService.GetAllJobDocuments(redirectCallback, JobID);
            setJobDocumentData(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    useEffect(() => {
        if (JobID > 0) {
            fetchJobDocument();
        }
        else {
            setJobDocumentData([])
        }
    }, [JobID]);
    const handleCreateJobDocumentClick = () => {
        setCurrentJobDocument(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (contact) => {
        setCurrentJobDocument(contact);
        setIsModalOpen(true);
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await JobDocumentService.DeleteJobDocument(redirectCallback, ID);
                    if ($.fn.DataTable.isDataTable(tableRef.current)) {
                        $(tableRef.current).DataTable().destroy();
                    }
                    fetchJobDocument();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const handleSuccess = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchJobDocument(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const getFileExtension = (fileName) => {
        const index = fileName.lastIndexOf('.');
        return index !== -1 ? fileName.substring(index) : '';
    };
    const handleDownload = async (e, docuemnt) => {
        e.stopPropagation();

        const ext = getFileExtension(docuemnt.FileName);
        const customName = `${docuemnt.Name}${ext}`;

        try {

            const response = await fetch(
                `${BASE_URL}/uploads/${CompanyID}/Job/Document/${docuemnt.FileName}`
            );
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = customName;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} disabled={isClosed === '1' || isClosed === 1} onClick={handleCreateJobDocumentClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className='divTable'>

                        <div style={{ maxHeight: "460px", overflow: "auto" }}>
                            <table ref={tableRef} className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Created Date</th>
                                        <th>Attached File</th>
                                        <th style={{ textAlign: "right" }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {JobDocuemntList.map((docuemnt) => (
                                        <tr key={docuemnt.DocID} onClick={(isClosed === '0' || isClosed === 0 || localStorage.getItem('LicenseExpired') == "0") ? () => handleEditClick(docuemnt) : undefined} style={{ cursor: 'pointer' }}>
                                            <td className="no-wrap">{docuemnt.Name}</td>
                                            <td className="no-wrap">{docuemnt.Description}</td>
                                             <td className="no-wrap">{docuemnt.CreatedDate}</td>
                                           
                                            <td>
                                                <a
                                                    href="#"
                                                    onClick={(e) => handleDownload(e, docuemnt)}
                                                    style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                                                >
                                                    {`${docuemnt.Name}${getFileExtension(docuemnt.FileName)}`}
                                                </a>
                                            </td>

                                            <td className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ textAlign: "right" }}>

                                                <button style={{ background: "none", border: "none" }} className="text-danger" disabled={isClosed === '1' || isClosed === 1} onClick={(event) => handleDeleteClick(event, docuemnt.DocID)}>
                                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
            {isModalOpen && (
                <CreateJobDocument
                    modalInstance={modalInstance}
                    currentJobDocument={currentJobDocument}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    JobID={JobID}
                />
            )}
        </div>
    );
}

export default JobDocumentPage;
